var _style, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreeniitLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 483.8 142.6",
    style: {
      enableBackground: "new 0 0 483.8 142.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#25A5C4;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#B5D560;}\n\t.st3{fill:#AACF40;stroke:#A9CF40;stroke-width:0.5755;}\n\t.st4{fill:#25A5C4;stroke:#25A5C4;stroke-width:2.3019;}\n\t.st5{fill:#25A5C4;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Shadow"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_137_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_181_",
    className: "st0",
    d: "M400.3,77.2c-1,3.1-10.5,4.7-9.4-1.3C394.6,72.1,396.5,77.1,400.3,77.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_180_",
    className: "st0",
    d: "M440.6,87.9c0.4,3.1-3.9,1.5-4,4C432.6,90.5,438.2,87.6,440.6,87.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_179_",
    className: "st0",
    d: "M408.3,2c1.8,0,3.6,0,5.4,0c3.4,5,10.8,2.4,14.8,4c-4.9,4.6-19.4-3.2-26.9,4 c4.6,2.7,16.7-2.6,22.8,1.3c-1.5,9.4,5,9.6,1.4,18.8c-21.2-3.6-38.3,2.2-47,17.5c-2.7-2.2-1.7,0.1-5.4,0c-2,0.6,0.5,1.7,0,4 c-9.6,3.1-13.1,19-10.8,29.6c1.1,4.6-2,7.7-1.3,1.3c-0.2-2.5-0.9-4.5-2.7-5.4c0.6-2.6,2.9-3.4,2.7-6.7 c-1.3-2.2-3.6-3.1-5.4-1.3c0-0.4,0-0.9,0-1.3c2.7-1.5,6.2,0.7,6.7-5.4c-3.2,0.9-2.5-4.5,1.3-6.7c-1-1.3-2.4-2-4-2.7 c0.4-2.7,3.6-2.6,4-5.4c-0.2-1.6-2.5-1.1-4-1.3c4.8-16.2,16.8-25.3,30.9-32.2C390.8,8.6,399.8,3.1,408.3,2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_178_",
    className: "st0",
    d: "M435.2,129.6c-0.4-3.1,3.9-1.5,4-4c2,0.6-0.5,1.7,0,4 C437.9,129.6,436.5,129.6,435.2,129.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_177_",
    className: "st0",
    d: "M373.4,18.1c3.6,1.6-3.5,3.5-4,5.4C365.8,21.9,372.9,20,373.4,18.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_176_",
    className: "st0",
    d: "M455.3,113.5c2.8-5.7,9.6-7.4,9.4-16.1c-6.1,5.1-10.2,12.2-14.8,18.8 c-14.5,5.8-24.6,14.8-43,10.7c1.2-2.8,7.6-0.5,8.1-4c-4.9-3.1-7.5,1.1-14.8,1.3c0.7-1.1,1.4-2.2,1.3-4c-3.2,0.4-5,2.1-9.4,1.3 c4.9-5.6-6.5-4.3-6.7-5.4c1.6-4.5,6.3,0.4,13.4,0c6.5-0.3,10.9-4.8,16.1-4c1.6-0.2,1.1-2.5,1.3-4c15.7-1.3,22-12,29.6-21.5 c-6.9-4.4-21.3-5.4-34.9-6.7c11.1-10.6,32.5,1.1,41.6-9.4c4.3-0.3,5.7,2.4,10.8,1.3c-3.6-6.4-0.5-6.9,0-14.8 c3.1,0.4,5-0.3,5.4-2.7c9,2.8,8.6,18.1,1.3,24.2c11.8,15.8-3.1,29-12.1,39C454.4,117.9,461.6,112.3,455.3,113.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_175_",
    className: "st0",
    d: "M369.4,105.4c4-2.2,8.5,6.6,14.8,6.7C378.5,115.9,374.3,106.8,369.4,105.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_174_",
    className: "st1",
    d: "M400.3,77.2c-1,3.1-10.5,4.7-9.4-1.3C394.6,72.1,396.5,77.1,400.3,77.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_173_",
    className: "st2",
    d: "M440.6,87.9c0.4,3.1-3.9,1.5-4,4C432.6,90.5,438.2,87.6,440.6,87.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_172_",
    className: "st1",
    d: "M408.3,2c1.8,0,3.6,0,5.4,0c3.4,5,10.8,2.4,14.8,4c-4.9,4.6-19.4-3.2-26.9,4 c4.6,2.7,16.7-2.6,22.8,1.3c-1.5,9.4,5,9.6,1.4,18.8c-21.2-3.6-38.3,2.2-47,17.5c-2.7-2.2-1.7,0.1-5.4,0c-2,0.6,0.5,1.7,0,4 c-9.6,3.1-13.1,19-10.8,29.6c1.1,4.6-2,7.7-1.3,1.3c-0.2-2.5-0.9-4.5-2.7-5.4c0.6-2.6,2.9-3.4,2.7-6.7 c-1.3-2.2-3.6-3.1-5.4-1.3c0-0.4,0-0.9,0-1.3c2.7-1.5,6.2,0.7,6.7-5.4c-3.2,0.9-2.5-4.5,1.3-6.7c-1-1.3-2.4-2-4-2.7 c0.4-2.7,3.6-2.6,4-5.4c-0.2-1.6-2.5-1.1-4-1.3c4.8-16.2,16.8-25.3,30.9-32.2C390.8,8.6,399.8,3.1,408.3,2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_171_",
    className: "st2",
    d: "M435.2,129.6c-0.4-3.1,3.9-1.5,4-4c2,0.6-0.5,1.7,0,4 C437.9,129.6,436.5,129.6,435.2,129.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_170_",
    className: "st1",
    d: "M373.4,18.1c3.6,1.6-3.5,3.5-4,5.4C365.8,21.9,372.9,20,373.4,18.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_169_",
    className: "st2",
    d: "M455.3,113.5c2.8-5.7,9.6-7.4,9.4-16.1c-6.1,5.1-10.2,12.2-14.8,18.8 c-14.5,5.8-24.6,14.8-43,10.7c1.2-2.8,7.6-0.5,8.1-4c-4.9-3.1-7.5,1.1-14.8,1.3c0.7-1.1,1.4-2.2,1.3-4c-3.2,0.4-5,2.1-9.4,1.3 c4.9-5.6-6.5-4.3-6.7-5.4c1.6-4.5,6.3,0.4,13.4,0c6.5-0.3,10.9-4.8,16.1-4c1.6-0.2,1.1-2.5,1.3-4c15.7-1.3,22-12,29.6-21.5 c-6.9-4.4-21.3-5.4-34.9-6.7c11.1-10.6,32.5,1.1,41.6-9.4c4.3-0.3,5.7,2.4,10.8,1.3c-3.6-6.4-0.5-6.9,0-14.8 c3.1,0.4,5-0.3,5.4-2.7c9,2.8,8.6,18.1,1.3,24.2c11.8,15.8-3.1,29-12.1,39C454.4,117.9,461.6,112.3,455.3,113.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_161_",
    className: "st2",
    d: "M369.4,105.4c4-2.2,8.5,6.6,14.8,6.7C378.5,115.9,374.3,106.8,369.4,105.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_132_",
    className: "st3",
    d: "M38.1,91.8c6.7,0,12.4,2.4,17.2,7.2c4.8,4.8,7.2,10.5,7.1,17.2c0,6.7-2.4,12.5-7.2,17.2 c-4.8,4.8-10.5,7.2-17.2,7.2c-6.7,0-12.5-2.4-17.2-7.2c-4.8-4.8-7.2-10.5-7.2-17.2c0-6.7,2.4-12.5,7.2-17.2 C25.6,94.2,31.3,91.8,38.1,91.8z M19.2,76.4l1.5,2.3c0.6,0.9,1.4,1.8,2.5,2.7c2.2,1.7,4.8,2.5,7.6,2.5H44c4.4,0,8.4,1.3,11.8,4 c1.7,1.4,3.1,2.8,4,4.3l1.4,2.3l-3.3,2l-2.2,1.4l-1.5-2.2c-0.5-0.9-1.4-1.8-2.6-2.6c-2.2-1.7-4.7-2.5-7.6-2.5H30.9 c-4.4,0-8.4-1.3-11.8-4c-1.8-1.4-3.2-2.9-4.1-4.4l-1.4-2.3l3.3-2L19.2,76.4z M38,134.2c5,0,9.2-1.8,12.7-5.2 c3.5-3.5,5.3-7.7,5.3-12.7c0-5-1.8-9.2-5.3-12.7C47.2,100,43,98.3,38,98.3c-5,0-9.2,1.7-12.7,5.3c-3.5,3.5-5.2,7.7-5.2,12.7 c0,5,1.7,9.2,5.2,12.7C28.8,132.4,33,134.2,38,134.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_130_",
    className: "st3",
    d: "M106.6,25.7c-1.7-0.4-3.4-0.7-5.2-0.7c-5.9,0-11,2.4-15.3,7.1c-4.2,4.8-6.4,10.6-6.5,17.3 v30.1h-5.8v-30C74,41,76.7,33.8,82,27.8c5.4-6,11.8-9.1,19.3-9.1c1.8,0,3.5,0.2,5.2,0.5V25.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_126_",
    className: "st4",
    d: "M152.7,71.1c-6,6-13.3,9-21.8,9c-8.5,0-15.8-3-21.8-9c-6-6-9.1-13.3-9.1-21.8 c0-8.5,3.1-15.8,9.1-21.8c6-6,13.3-9.1,21.8-9.1c8.5,0,15.8,3,21.8,9.1c1.8,1.8,3,3.3,3.8,4.5c0.8-1.2,2-2.7,3.8-4.5 c6-6,13.3-9.1,21.8-9.1c8.5,0,15.8,3,21.8,9.1c4.1,4.1,7.1,9.1,8.9,15.1L158,42.3c-0.6,2-0.9,4.3-0.9,6.9 c0,6.9,2.4,12.8,7.3,17.7c4.9,4.9,10.8,7.3,17.7,7.3c6.9,0,12.8-2.4,17.7-7.3c2.8-2.8,4.9-6.1,6.2-9.9h6.1 c-1.6,5.6-4.3,10.2-8.2,14c-6.1,6-13.3,9-21.8,9c-8.5,0-15.8-3-21.8-9c-6-6-9.1-13.3-9.1-21.8c0-2.8,0.2-5.1,0.7-6.8l-45.3-0.2 c-0.6,2-0.9,4.3-0.9,6.9c0,6.9,2.4,12.8,7.3,17.7c4.9,4.9,10.8,7.3,17.7,7.3c6.9,0,12.8-2.4,17.7-7.3c1-1,2.1-2.3,3.3-4l3.1,5.6 C154.2,69.5,153.4,70.4,152.7,71.1z M152.6,36.7c-0.7-1.4-2.1-3.1-4-5.1c-4.9-4.9-10.8-7.3-17.7-7.3c-6.9,0-12.8,2.4-17.7,7.3 c-1.9,2-3.3,3.7-4,5.1H152.6z M203.9,36.7c-0.7-1.4-2.1-3.1-4-5.1c-4.9-4.9-10.8-7.3-17.7-7.3c-6.9,0-12.8,2.4-17.7,7.3 c-1.9,2-3.3,3.7-4,5.1H203.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_124_",
    className: "st3",
    d: "M215.6,49.5c0.1-8.5,2.8-15.7,8.2-21.7c5.4-6,11.8-9.1,19.3-9.1c7.6,0,14,3,19.4,9.1 c5.3,6,8,13.2,8.1,21.8v30h-5.8v-30c-0.1-6.8-2.2-12.6-6.5-17.4c-4.2-4.8-9.3-7.2-15.2-7.2c-5.9,0-11,2.4-15.3,7.1 c-4.2,4.8-6.4,10.6-6.5,17.3v30.1h-5.8V49.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_121_",
    className: "st3",
    d: "M285.2,19.5h-5.9v-5h5.9V19.5z M285.2,79.5h-5.9V25.7h5.9V79.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_118_",
    className: "st3",
    d: "M299.7,18.2h-5.9v-5.1h5.9V18.2z M299.7,79.5h-5.9v-55h5.9V79.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_116_",
    className: "st3",
    d: "M323.5,25h13.8v5.3h-13.8v49.1h-6V30.4h-13.7V25h13.7V13.8h5.9V25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_113_",
    className: "st3",
    d: "M64.3,30.5c4.2,5.3,6.3,11.5,6.3,18.9c0,8.6-3,15.9-9.1,22c-6.1,6.1-13.4,9.1-22,9.1 c-8.6,0-15.9-3-22-9.1c-6.1-6.1-9.2-13.5-9.2-22c0-8.6,3.1-15.9,9.2-22c6.1-6.1,13.4-9.2,22-9.2c8.3,0,15,2.5,20.3,7.5 c1.3-2.1,0.5-5.4-2.3-9.9l5.2-2.3l1.5,3.4c1.6,3.5,1.9,7.1,1,10.8C64.9,29,64.6,29.9,64.3,30.5z M39.4,74.7 c7,0,12.9-2.5,17.9-7.4c4.9-4.9,7.4-10.9,7.4-17.9c0-7-2.5-12.9-7.4-17.9c-4.9-4.9-10.9-7.4-17.9-7.4c-7,0-12.9,2.4-17.9,7.4 c-4.9,4.9-7.4,10.9-7.4,17.9c0,7,2.5,12.9,7.4,17.9C26.5,72.3,32.4,74.7,39.4,74.7z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_111_",
    className: "st5",
    d: "M79.7,107.7c0,1.4-0.4,2.2-1.2,2.2h-4.3c-0.8,0-1.2-0.7-1.2-2.2V88.5 c0-1.4,0.4-2.2,1.2-2.2h4.3c0.8,0,1.2,0.7,1.2,2.2v5h-2.1v-4.2h-2.7v17.5h2.7v-6.6h-1.5v-3h3.6V107.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_109_",
    className: "st5",
    d: "M86.9,101h-2v-3.5l-1.6,0v12.3h-2V94.7h2v0.5c0.4-0.1,0.8-0.3,1.2-0.4 c0.5-0.2,0.9-0.2,1.2-0.2c0.7,0,1.1,0.6,1.1,1.9V101z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_106_",
    className: "st5",
    d: "M93.8,108c0,1.3-0.4,1.9-1.1,1.9h-3.5c-0.8,0-1.1-0.6-1.1-1.9V96.5c0-1.3,0.4-1.9,1.1-1.9 h3.5c0.8,0,1.1,0.6,1.1,1.9v5.6l-0.6,1h-3.3v4.2h1.9v-2.5h1.9V108z M91.8,100.8v-3.6h-1.9v3.6H91.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_103_",
    className: "st5",
    d: "M101,108c0,1.3-0.4,1.9-1.1,1.9h-3.5c-0.8,0-1.1-0.6-1.1-1.9V96.5c0-1.3,0.4-1.9,1.1-1.9 h3.5c0.8,0,1.1,0.6,1.1,1.9v5.6l-0.6,1h-3.3v4.2H99v-2.5h1.9V108z M99,100.8v-3.6h-1.9v3.6H99z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_101_",
    className: "st5",
    d: "M108.4,109.9h-2V97.5l-1.9,0v12.3h-2V94.7h2v0.5c0.5-0.1,0.9-0.3,1.4-0.4 c0.6-0.2,1.1-0.3,1.4-0.3c0.7,0,1.1,0.6,1.1,1.9V109.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_99_",
    className: "st5",
    d: "M115.8,109.9h-2.1V86.3h2.1V109.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_97_",
    className: "st5",
    d: "M123.3,109.9h-2V97.5l-1.9,0v12.3h-2V94.7h2v0.5c0.5-0.1,0.9-0.3,1.4-0.4 c0.6-0.2,1.1-0.3,1.4-0.3c0.7,0,1.1,0.6,1.1,1.9V109.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_95_",
    className: "st5",
    d: "M128.6,109.9h-2.2c-0.7,0-1.1-0.6-1.1-1.9V97.6h-1v-2.9h1v-4.1h2v4.1h1.3v2.9h-1.3v9.3h1.3 V109.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_92_",
    className: "st5",
    d: "M135.5,108c0,1.3-0.4,1.9-1.1,1.9h-3.5c-0.8,0-1.1-0.6-1.1-1.9V96.5c0-1.3,0.4-1.9,1.1-1.9 h3.5c0.8,0,1.1,0.6,1.1,1.9v5.6l-0.6,1h-3.3v4.2h1.9v-2.5h1.9V108z M133.5,100.8v-3.6h-1.9v3.6H133.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_88_",
    className: "st5",
    d: "M142.8,113.5c0,1.3-0.4,1.9-1.1,1.9h-3.5c-0.8,0-1.1-0.6-1.1-1.9v-2.4h1.9v1.8h1.8v-3.1 h-2.1c-0.6,0-1-0.3-1.4-0.8c-0.3-0.5-0.5-1.3-0.5-2.2v-9.3c0-0.9,0.1-1.6,0.4-2.1c0.3-0.5,0.7-0.8,1.2-0.8c0.2,0,1,0.2,2.3,0.6 v-0.5h2V113.5z M140.8,107v-9.4c-0.7-0.1-1.1-0.2-1.3-0.2c-0.4,0-0.7,0.4-0.7,1.1v7.3c0,0.8,0.2,1.2,0.7,1.2H140.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_85_",
    className: "st5",
    d: "M149.9,101h-2v-3.5l-1.6,0v12.3h-2V94.7h2v0.5c0.4-0.1,0.8-0.3,1.2-0.4 c0.5-0.2,0.9-0.2,1.2-0.2c0.7,0,1.1,0.6,1.1,1.9V101z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_82_",
    className: "st5",
    d: "M156.8,109.9h-1.9v-0.5c-0.5,0.1-0.9,0.2-1.4,0.4c-0.6,0.1-1,0.2-1.4,0.2 c-0.7,0-1.1-0.6-1.1-1.9v-5.5c0-1.3,0.4-1.9,1.1-1.9h2.7v-3.5H153v2.2h-1.8v-2.8c0-1.3,0.4-1.9,1.1-1.9h3.4 c0.7,0,1.1,0.6,1.1,1.9V109.9z M154.9,107.1V103H153v4.2L154.9,107.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_80_",
    className: "st5",
    d: "M162.1,109.9h-2.2c-0.7,0-1.1-0.6-1.1-1.9V97.6h-0.9v-2.9h0.9v-4.1h2v4.1h1.3v2.9h-1.3v9.3 h1.4V109.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_77_",
    className: "st5",
    d: "M169,108c0,1.3-0.4,1.9-1.1,1.9h-3.5c-0.8,0-1.2-0.6-1.2-1.9V96.5c0-1.3,0.4-1.9,1.2-1.9 h3.5c0.8,0,1.1,0.6,1.1,1.9v5.6l-0.6,1h-3.3v4.2h1.9v-2.5h1.9V108z M167,100.8v-3.6h-1.9v3.6H167z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_74_",
    className: "st5",
    d: "M176.3,109.9h-2v-0.5c-1.4,0.4-2.1,0.6-2.3,0.6c-0.5,0-0.9-0.3-1.2-0.8 c-0.3-0.5-0.4-1.2-0.4-2.1v-9.4c0-1.2,0.3-2.1,0.8-2.6c0.4-0.4,1-0.5,1.7-0.5c0.2,0,0.4,0,0.7,0c0.3,0,0.5,0,0.7,0v-8.4h2 V109.9z M174.3,106.9v-9.4h-1.2c-0.4,0-0.7,0.4-0.7,1.1v7.3c0,0.7,0.2,1.1,0.6,1.1C173.2,107.1,173.6,107,174.3,106.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_72_",
    className: "st5",
    d: "M183.7,109.9h-2.1V86.3h2.1V109.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_65_",
    className: "st5",
    d: "M191.3,109.9h-2V97.5l-1.9,0v12.3h-2V94.7h2v0.5c0.5-0.1,0.9-0.3,1.4-0.4 c0.6-0.2,1-0.3,1.4-0.3c0.7,0,1.1,0.6,1.1,1.9V109.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_63_",
    className: "st5",
    d: "M196.6,89.3h-1.5v5.4h1.3v2.9h-1.3v12.3h-2V97.6h-0.9v-2.9h0.9v-6.5c0-1.3,0.4-1.9,1.1-1.9 h2.4V89.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_60_",
    className: "st5",
    d: "M203.3,108c0,1.3-0.4,1.9-1.1,1.9h-3.6c-0.8,0-1.1-0.6-1.1-1.9V96.5c0-1.3,0.4-1.9,1.1-1.9 h3.6c0.7,0,1.1,0.6,1.1,1.9V108z M201.3,107v-9.5h-1.9v9.5H201.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_58_",
    className: "st5",
    d: "M210.3,101h-2v-3.5l-1.6,0v12.3h-2V94.7h2v0.5c0.4-0.1,0.8-0.3,1.2-0.4 c0.5-0.2,0.9-0.2,1.3-0.2c0.7,0,1.1,0.6,1.1,1.9V101z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_56_",
    className: "st5",
    d: "M221.3,109.9h-2V97.5l-1.9,0v12.3h-2V97.5l-1.9,0v12.3h-2V94.7h2v0.5 c0.5-0.1,0.9-0.3,1.4-0.4c0.6-0.2,1.1-0.2,1.4-0.2c0.5,0,0.8,0.2,0.9,0.7c0.5-0.1,1-0.3,1.5-0.4c0.7-0.2,1.2-0.3,1.5-0.3 c0.7,0,1.1,0.6,1.1,1.9V109.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_53_",
    className: "st5",
    d: "M228.5,109.9h-1.9v-0.5c-0.4,0.1-0.9,0.2-1.4,0.4c-0.6,0.1-1.1,0.2-1.4,0.2 c-0.7,0-1.1-0.6-1.1-1.9v-5.5c0-1.3,0.4-1.9,1.1-1.9h2.7v-3.5h-1.9v2.2h-1.8v-2.8c0-1.3,0.4-1.9,1.1-1.9h3.4 c0.7,0,1.1,0.6,1.1,1.9V109.9z M226.6,107.1V103h-1.9v4.2L226.6,107.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_36_",
    className: "st5",
    d: "M233.8,109.9h-2.2c-0.7,0-1.1-0.6-1.1-1.9V97.6h-1v-2.9h1v-4.1h2v4.1h1.3v2.9h-1.3v9.3h1.4 V109.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_33_",
    className: "st5",
    d: "M236.9,92.5h-2v-3.5h2V92.5z M236.9,109.9h-2V94.7h2V109.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_30_",
    className: "st5",
    d: "M244.3,108c0,1.3-0.4,1.9-1.1,1.9h-3.6c-0.8,0-1.1-0.6-1.1-1.9V96.5c0-1.3,0.4-1.9,1.1-1.9 h3.6c0.7,0,1.1,0.6,1.1,1.9V108z M242.3,107v-9.5h-1.9v9.5H242.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28_",
    className: "st5",
    d: "M251.7,109.9h-2V97.5l-1.9,0v12.3h-2V94.7h2v0.5c0.5-0.1,0.9-0.3,1.4-0.4 c0.6-0.2,1-0.3,1.4-0.3c0.7,0,1.1,0.6,1.1,1.9V109.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_26_",
    className: "st5",
    d: "M263,89.4h-2.3v20.4h-2.1V89.4h-2.3v-3.1h6.6V89.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_23_",
    className: "st5",
    d: "M269.7,108c0,1.3-0.4,1.9-1.1,1.9H265c-0.7,0-1.1-0.6-1.1-1.9V96.5c0-1.3,0.4-1.9,1.1-1.9 h3.5c0.8,0,1.1,0.6,1.1,1.9v5.6l-0.5,1h-3.3v4.2h1.9v-2.5h1.9V108z M267.7,100.8v-3.6h-1.9v3.6H267.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_21_",
    className: "st5",
    d: "M276.9,108c0,1.3-0.4,1.9-1.1,1.9h-3.5c-0.8,0-1.1-0.6-1.1-1.9V96.5c0-1.3,0.4-1.9,1.1-1.9 h3.5c0.7,0,1.1,0.6,1.1,1.9v3.6h-2v-2.6h-1.8v9.5h1.8v-2.9h2V108z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_19_",
    className: "st5",
    d: "M284.3,109.9h-2V97.5l-1.9,0v12.3h-2V86.3h2v8.9c0.5-0.1,0.9-0.2,1.4-0.4 c0.6-0.2,1.1-0.3,1.4-0.3c0.7,0,1.1,0.6,1.1,1.9V109.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_17_",
    className: "st5",
    d: "M291.7,109.9h-2V97.5l-1.9,0v12.3h-2V94.7h2v0.5c0.5-0.1,1-0.3,1.4-0.4 c0.6-0.2,1.1-0.3,1.4-0.3c0.7,0,1.1,0.6,1.1,1.9V109.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_14_",
    className: "st5",
    d: "M299,108c0,1.3-0.4,1.9-1.1,1.9h-3.6c-0.8,0-1.1-0.6-1.1-1.9V96.5c0-1.3,0.4-1.9,1.1-1.9 h3.6c0.8,0,1.1,0.6,1.1,1.9V108z M297,107v-9.5h-1.9v9.5H297z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_12_",
    className: "st5",
    d: "M302.5,109.9h-2V86.3h2V109.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9_",
    className: "st5",
    d: "M309.9,108c0,1.3-0.4,1.9-1.1,1.9h-3.6c-0.8,0-1.1-0.6-1.1-1.9V96.5c0-1.3,0.4-1.9,1.1-1.9 h3.6c0.8,0,1.1,0.6,1.1,1.9V108z M307.9,107v-9.5H306v9.5H307.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6_",
    className: "st5",
    d: "M317.2,113.5c0,1.3-0.4,1.9-1.1,1.9h-3.5c-0.8,0-1.1-0.6-1.1-1.9v-2.4h2v1.8h1.8v-3.1h-2.1 c-0.6,0-1-0.3-1.3-0.8c-0.3-0.5-0.5-1.3-0.5-2.2v-9.3c0-0.9,0.1-1.6,0.4-2.1c0.3-0.5,0.7-0.8,1.2-0.8c0.3,0,1,0.2,2.3,0.6v-0.5 h2V113.5z M315.2,107v-9.4c-0.7-0.1-1.1-0.2-1.3-0.2c-0.4,0-0.6,0.4-0.6,1.1v7.3c0,0.8,0.2,1.2,0.7,1.2H315.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    className: "st5",
    d: "M324.7,94.7l-2.2,15l-0.9,5.8h-2.1l0.9-5.7l-2.3-15.1h2.1l1.2,10l1.2-10H324.7z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreeniitLogo);
export default __webpack_public_path__ + "static/media/greeniit_logo.96d72fdaaf126e9ab62b59974fe5f0f3.svg";
export { ForwardRef as ReactComponent };